<template>
    <layout>
        <template slot="content">
            <div v-if="!noReturnPage" class="ini-detail__navigation">
                <a href="#" @click.prevent="returnToIndex">{{ getReturnPageTitle }}</a>
            </div>
            <content-title :title="title" :icon="icon"></content-title>
            <div class="ini-detail__grid">
                <div class="ini-detail__summary">
                    <slot name="summary"></slot>
                </div>
                <div class="ini-detail__main">
                    <slot name="main"></slot>
                </div>
                <div class="ini-detail__custom">
                    <slot name="custom"></slot>
                </div>
            </div>
        </template>
    </layout>
</template>

<script>
    import Layout from '@/layout/Boxed'
    import ContentTitle from '@/components/ContentTitle';

    export default {
        data() {
            return {
                ticket_title: {value: 'Title', displayValue: 'Gravida quis blandit turpis cursus'},
                ticket_num: {value: 'TT16', displayValue: 'TT16'},
                description: {value: 'Description', displayValue: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaeca'},
                ticketcategories: {value: 'Question', displayValue: 'Question'},
                ticketstatus: {value: 'Open', displayValue: 'Open'},
                createdtime: {value: '2019-04-11 11:40:34', displayValue: '2019-04-11 11:40 AM'},
                ticketpriorities: {value: 'Urgent', displayValue: 'Urgent'},
                handledby: {value: '11', displayValue: 'Pierre-Mickael D.'},
            }
        },

        props: {
            title: String,
            icon: String,
            returnPageTitle: String,
            returnPagePath: String,
            noReturnPage: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            getReturnPageTitle() {
                if(this.returnPageTitle) {
                    return this.returnPageTitle;
                }

                let structure = this.$store.getters.getStructure
                if(structure) {
                    return this.$t('LBL_LIST').replace('$module$', structure.modules[this.$route.params.module].label)
                }

                return this.returnPageTitle;
            }
        },

        methods: {
          returnToIndex() {
              this.$router.push({name: 'Index', params: {module: this.$route.params.module, view: 'Index'}});
          }
        },

        components: {
            Layout,
            ContentTitle
        }
    }
</script><style lang="scss">@import "@/assets/scss/layout/_detail.scss";</style>